import React, { Fragment, useContext, useState, useEffect } from 'react'
import styled from '@emotion/styled'
import { withTheme } from 'emotion-theming'
import { withRouter, Link as RouterLink } from 'react-router-dom'
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined'
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline'
import CreateOutlinedIcon from '@material-ui/icons/CreateOutlined'
import WorkOutlineIcon from '@material-ui/icons/WorkOutline'
import MonetizationOnOutlinedIcon from '@material-ui/icons/MonetizationOnOutlined'
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd'
import { WebAssetOutlined } from '@material-ui/icons'
import { SvgIcon } from '@material-ui/core'

import ModalSidebar from './ModalSidebar'

import { GlobalContext } from '../../contexts'

const Sidebar = ({ isOpen, setIsOpen, history }) => {
  const globalState = useContext(GlobalContext)

  const [menu, setMenu] = useState('-')

  const handleCloseMenu = () => setIsOpen(false)

  useEffect(() => {
    setMenu(history.location.pathname + history.location.search)
  }, [history])

  return (
    <Fragment>
      <Container isOpen={isOpen}>
        <ContainerSidebar isOpen={isOpen}>
          <InsideContainer isOpen={isOpen}>
            <Category isOpen={isOpen} selected={menu.includes('/campanha')}>
              <CategoryTitleContainer>
                <Link
                  to='/'
                  onClick={() => {
                    handleCloseMenu()
                    setMenu('/campanha')
                  }}
                >
                  <StyledHomeIcon />
                  <CategoryTitle isOpen={isOpen}>Campanhas </CategoryTitle>
                </Link>
              </CategoryTitleContainer>
            </Category>
            <Category isOpen={isOpen} selected={menu.includes('/controle-operacao')}>
              <CategoryTitleContainer>
                <Link
                  to='/controle-operacao'
                  onClick={() => {
                    handleCloseMenu()
                    setMenu('/controle-operacao')
                  }}
                >
                  <SvgIcon style={{ marginLeft: '7px' }}>
                    <svg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
                      <path
                        d='M13 15V12H16V10L20 13.5L16 17V15H13ZM15 16V19H12V21L7.99996 17.5L12 14V16H15ZM9.99996 6C7.78996 6 5.99996 7.8 5.99996 10C5.99996 11.91 7.34996 13.54 9.20996 13.92L14 9.86C13.9644 8.82334 13.5272 7.84109 12.7808 7.12081C12.0344 6.40052 11.0372 5.99861 9.99996 6ZM9.99996 12C8.89996 12 7.99996 11.11 7.99996 10C7.99996 8.89 8.89996 8 9.99996 8C11.1 8 12 8.9 12 10C12 11.1 11.11 12 9.99996 12ZM19.66 6.73L17.66 3.27C17.54 3.05 17.28 2.96 17.05 3.05L14.56 4.05C14.05 3.64 13.5 3.31 12.87 3.05L12.5 0.420002C12.4797 0.302219 12.4183 0.195429 12.3268 0.118553C12.2353 0.0416778 12.1195 -0.000319774 12 1.83347e-06H7.99996C7.74996 1.83347e-06 7.53996 0.180002 7.49996 0.420002L7.12996 3.07C6.49996 3.33 5.95996 3.66 5.43996 4.07L2.99996 3.05C2.76996 2.96 2.49996 3.05 2.38996 3.27L0.389964 6.73C0.259964 6.94 0.309964 7.22 0.499964 7.37L2.56996 9L2.49996 10L2.56996 11L0.459964 12.63C0.259964 12.78 0.209964 13.06 0.339964 13.27L2.33996 16.73C2.44996 17 2.73996 17.11 2.99996 17L5.49996 16C5.73996 16.19 5.99996 16.37 6.25996 16.53L7.90996 15.13C7.13996 14.8 6.45996 14.31 5.90996 13.68L3.49996 14.68L2.72996 13.38L4.79996 11.8C4.39996 10.6333 4.39996 9.36667 4.79996 8.2L2.68996 6.65L3.43996 5.35L5.84996 6.35C6.62996 5.45 7.67996 4.82 8.84996 4.57L9.24996 2H10.75L11.12 4.62C12.29 4.86 13.34 5.5 14.12 6.39L16.53 5.39L17.28 6.69L15.2 8.2C15.29 8.46 15.36 8.73 15.4 9H17.4L19.5 7.37C19.6034 7.30398 19.6776 7.20087 19.7073 7.08184C19.7371 6.96282 19.7201 6.83692 19.66 6.73ZM9.99996 6C7.78996 6 5.99996 7.8 5.99996 10C5.99996 11.91 7.34996 13.54 9.20996 13.92L14 9.86C13.9644 8.82334 13.5272 7.84109 12.7808 7.12081C12.0344 6.40052 11.0372 5.99861 9.99996 6ZM9.99996 12C8.89996 12 7.99996 11.11 7.99996 10C7.99996 8.89 8.89996 8 9.99996 8C11.1 8 12 8.9 12 10C12 11.1 11.11 12 9.99996 12ZM9.99996 6C7.78996 6 5.99996 7.8 5.99996 10C5.99996 11.91 7.34996 13.54 9.20996 13.92L14 9.86C13.9644 8.82334 13.5272 7.84109 12.7808 7.12081C12.0344 6.40052 11.0372 5.99861 9.99996 6ZM9.99996 12C8.89996 12 7.99996 11.11 7.99996 10C7.99996 8.89 8.89996 8 9.99996 8C11.1 8 12 8.9 12 10C12 11.1 11.11 12 9.99996 12Z'
                        fill='white'
                      />
                    </svg>
                  </SvgIcon>
                  <CategoryTitle isOpen={isOpen}>Controle de Operações</CategoryTitle>
                </Link>
              </CategoryTitleContainer>
            </Category>
            <Category isOpen={isOpen} selected={menu.includes('/usuarios?role=S')}>
              <Link
                to='/usuarios?role=S'
                onClick={() => {
                  handleCloseMenu()
                  setMenu('/usuarios?role=S')
                }}
              >
                <StyledSubscribersIcon />
                <CategoryTitle isOpen={isOpen}>Assinantes</CategoryTitle>
              </Link>
            </Category>
            <Category isOpen={isOpen} selected={menu.includes('/usuarios?role=I')}>
              <Link
                to='/usuarios?role=I'
                onClick={() => {
                  handleCloseMenu()
                  setMenu('/usuarios?role=I')
                }}
              >
                <StyledPeopleIcon />
                <CategoryTitle isOpen={isOpen}>Investidores</CategoryTitle>
              </Link>
            </Category>
            <Category isOpen={isOpen} selected={menu.includes('/parceiros')}>
              <Link
                to='/parceiros'
                onClick={() => {
                  handleCloseMenu()
                  setMenu('/parceiros')
                }}
              >
                <StyledWorkIcon />
                <CategoryTitle isOpen={isOpen}>Parcerias</CategoryTitle>
              </Link>
            </Category>
            <Category isOpen={isOpen} selected={menu.includes('/solicitacoes-de-credito')}>
              <Link
                to='/solicitacoes-de-credito'
                onClick={() => {
                  handleCloseMenu()
                  setMenu('/solicitacoes-de-credito')
                  if (globalState.refreshLeadsClean) globalState.refreshLeadsClean()
                }}
              >
                <StyledMonetizationIcon />
                <CategoryTitle isOpen={isOpen}>Solicitações de Crédito</CategoryTitle>
              </Link>
            </Category>
            <Category isOpen={isOpen} selected={menu.includes('/funcionarios')}>
              <Link
                to='/funcionarios'
                onClick={() => {
                  handleCloseMenu()
                  setMenu('/funcionarios')
                  if (globalState.refreshLeadsClean) globalState.refreshLeadsClean()
                }}
              >
                <StyledAssignmentIndIcon />
                <CategoryTitle isOpen={isOpen}>Funcionários</CategoryTitle>
              </Link>
            </Category>
            <Category isOpen={isOpen} selected={menu.includes('/home')}>
              <Link
                to='/home'
                onClick={() => {
                  handleCloseMenu()
                  setMenu('/home')
                }}
              >
                <StyledHomeSiteIcon />
                <CategoryTitle isOpen={isOpen}>Conteúdo da Home</CategoryTitle>
              </Link>
            </Category>
          </InsideContainer>
        </ContainerSidebar>
      </Container>
      <ModalSidebar isOpen={isOpen} setIsOpen={setIsOpen} />
    </Fragment>
  )
}

const CategoryTitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const CategoryTitle = styled.span`
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  transition: 0.2s;
  white-space: nowrap;
  margin-left: 10px;
  margin-right: 80px;
  font-size: 14px;
  font-weight: 500;
`

const Container = styled.div`
  width: ${({ isOpen }) => (isOpen ? 260 : 65)}px;
  @media (max-width: 768px) {
    display: none;
  }
`

const InsideContainer = styled.div`
  padding-top: 78px;
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: 100%;
  ::-webkit-scrollbar {
    width: 0px;
    background: transparent;
  }
`
const StyledHomeSiteIcon = styled(WebAssetOutlined)`
  color: ${({ theme }) => theme.colors.white};
  margin-left: 6px;
`

const StyledHomeIcon = styled(HomeOutlinedIcon)`
  color: ${({ theme }) => theme.colors.white};
  margin-left: 6px;
`

const StyledPeopleIcon = styled(PeopleOutlineIcon)`
  color: ${({ theme }) => theme.colors.white};
  margin-left: 6px;
`
const StyledSubscribersIcon = styled(CreateOutlinedIcon)`
  color: ${({ theme }) => theme.colors.white};
  margin-left: 6px;
`

const StyledWorkIcon = styled(WorkOutlineIcon)`
  color: ${({ theme }) => theme.colors.white};
  margin-left: 6px;
`

const StyledMonetizationIcon = styled(MonetizationOnOutlinedIcon)`
  color: ${({ theme }) => theme.colors.white};
  margin-left: 6px;
`
const StyledAssignmentIndIcon = styled(AssignmentIndIcon)`
  color: ${({ theme }) => theme.colors.white};
  margin-left: 6px;
`

const Category = styled.div`
  width: ${({ isOpen }) => (isOpen ? 260 : 65)}px;
  padding: 15px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.blue};
  transition: 0.2s;

  border-right: 4px solid ${({ selected }) => (selected ? '#3DC6EF' : '#2375a8')};
`

const ContainerSidebar = styled.div`
  position: fixed;
  width: ${({ isOpen }) => (isOpen ? 260 : 65)}px;
  top: 0px;
  left: 0px;
  height: 100vh;
  background: ${({ theme }) => theme.colors.blueKavod};
  @media (max-width: 768px) {
    display: none;
  }
  z-index: 3;
`

const Link = styled(RouterLink)`
  cursor: pointer;
  background: none;
  border: none;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: center;
  &:focus {
    outline: 0;
  }
`

export default withRouter(withTheme(Sidebar))
